import entry from '@rtl/ssr/client'

import createApp from './app'

// @ts-expect-error Export for articles in CkEditor
import(/* webpackChunkName: "editor" */ '@ui/assets/style/editor.scss')

entry(createApp)
